import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  admins: [],
  admin: {}
}

export const mutations = {
  SET_ADMINS(state, admins) {
    state.admins = admins
  },
  SET_ADMIN(state, admin) {
    state.admin = admin
  },
  ADD_ADMIN(state, admin) {
    state.admins.push(admin)
  },
  EDIT_ADMIN_ACTIVE(state, adminActive) {
    const item = state.admins.find(
      el => el.company_admin_id === adminActive.company_admin_id
    )
    if (item) {
      item.is_active = adminActive.is_active
    }
  },
  EDIT_ADMIN(state, admin) {
    const index = state.admins.findIndex(
      el => el.company_admin_uuid === admin.company_admin_uuid
    )
    if (index !== -1) {
      state.admins.splice(index, 1, admin)
    }
  },
  DELETE_ADMIN(state, companyAdminUUID) {
    const index = state.admins.findIndex(
      el => el.company_admin_uuid === companyAdminUUID
    )
    if (index !== -1) state.admins.splice(index, 1)
  }
}

export const actions = {
  fetchAdmins({ commit }, companyUUID) {
    return ApiService.fetchAdmins(companyUUID)
      .then(res => {
        const admins = res.data.data
        commit('SET_ADMINS', admins)
      })
      .catch(error => {
        throw error
      })
  },
  fetchAdmin({ commit, getters, state }, id) {
    if (state.admin.company_admin_id === id) {
      return state.admin
    }

    const admin = getters.getAdminById(id)

    if (admin) {
      commit('SET_ADMIN', admin)
      return admin
    } else {
      return ApiService.fetchAdmin(id)
        .then(res => {
          const admin = res.data
          commit('SET_ADMIN', admin)
          return admin
        })
        .catch(error => {
          throw error
        })
    }
  },
  addAdmin({ commit }, payload) {
    return ApiService.addAdmin(payload)
      .then(res => {
        const admin = res.data
        commit('ADD_ADMIN', admin)
      })
      .catch(error => {
        throw error
      })
  },
  editAdminActive({ commit }, adminActiveUpdate) {
    return ApiService.editAdminActive(adminActiveUpdate)
      .then(res => {
        const adminActive = res.data
        commit('EDIT_ADMIN_ACTIVE', adminActive)
      })
      .catch(error => {
        throw error
      })
  },
  editAdmin({ commit }, payload) {
    return ApiService.editAdmin(payload)
      .then(res => {
        const admin = res.data
        commit('EDIT_ADMIN', admin)
      })
      .catch(error => {
        throw error
      })
  },
  deleteAdmin({ commit }, payload) {
    return ApiService.deleteAdmin(payload)
      .then(() => {
        commit('DELETE_ADMIN', payload.companyAdminUUID)
      })
      .catch(error => {
        throw error
      })
  }
}

export const getters = {
  getAdminById: state => id => {
    return state.admins.find(el => el.company_admin_id === id)
  }
}
